// extracted by mini-css-extract-plugin
module.exports = {"collapse_button":"a10a3f92e9--collapse_button--1xyr0","arrow":"a10a3f92e9--arrow--3Nrq9","collapse_button--collapsed":"a10a3f92e9--collapse_button--collapsed--21nQ5"};